const meses = [ 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro' ];

// export default [
//   {
//     ano: '2020',
//     agenda: [
//       {
//         titulo: 'Vestibular de Medicina São Luís – 1º semestre de 2020',
//         local: 'Campus Renascença',
//         periodo: 'Outubro',
//         inscricoes: `<b>Inscrições:</b> de 27 de agosto a 21 de outubro.`,
//         cartaoInscricao: `<b>Cartão de inscrição:</b> 25 de outubro.`,
//         dias: `<b>Provas:</b> 27 de outubro.`,
//         horarios: [
//           { hora: 'Domingo', dias: '27 de outubro' },
//         ],
//         resultados: `<b>Resultado:</b> 18 de novembro.`,
//         matriculas: `
//           <b>Matrícula 1º sem (1º a 79º):</b> de 2 a 6 de dezembro`,
//         prazo: ' ',
//         linkVestibular: 'Inscrição aqui no <a href="/novoportal/vestibular/ceuma">Portal</a>',
//       },
//       {
//         titulo: 'Vestibular de Medicina Imperatriz – 1º semestre de 2020',
//         local: 'Campus Imperatriz',
//         periodo: 'Novembro',
//         inscricoes: `<b>Inscrições:</b> de 27 de agosto a 11 de novembro.`,
//         cartaoInscricao: `<b>Cartão de inscrição:</b> 14 de novembro.`,
//         dias: `<b>Provas:</b> 17 de novembro.`,
//         horarios: [
//           { hora: 'Domingo', dias: '17 de novembro' },
//         ],
//         resultados: `<b>Resultado:</b> 04 de dezembro, às 20h.`,
//         matriculas: `
//           <b>Matrícula 1º sem (1º a 50º):</b> de 9 a 13 de dezembro`,
//         prazo: ' ',
//         linkVestibular: 'Inscrição aqui no <a href="/novoportal/vestibular/ceuma">Portal</a>',
//       }
//     ]
//   },
// ];

export default [
  {
    ano: '2021',
    agenda: [
      {
        titulo: 'Vestibular de Medicina São Luís – 2º semestre de 2021.2',
        local: 'Campus Renascença',
        periodo: 'Junho',
        inscricoes: `<b>Inscrições:</b> de 24 de abril a 04 de junho.`,
        cartaoInscricao: `<b>Validação das inscrições:</b> 07 a 11 de junho.`,
        dias: null,
        horarios: [
          { hora: 'Domingo', dias: '27 de outubro' },
        ],
        resultados: `<b>Resultado:</b> 15 de junho.`,
        matriculas: `
          <b>Matrícula 2º semestre:</b> de 16 a 22 de junho`,
        prazo: ' ',
        linkVestibular: 'Inscrição aqui no <a href="https://www.extranet.ceuma.br/novoportal/vestibular/ceuma">Portal</a>',
      },
      {
        titulo: 'Vestibular de Medicina Imperatriz – 2º semestre de 2021.2',
        local: 'Campus Imperatriz',
        periodo: 'Junho',
        inscricoes: `<b>Inscrições:</b> de 24 de abril a 04 de junho.`,
        cartaoInscricao: `<b>Validação das inscrições:</b> 07 a 11 de junho.`,
        dias: null,
        horarios: [
          { hora: 'Domingo', dias: '17 de novembro' },
        ],
        resultados: `<b>Resultado:</b> 15 de junho.`,
        matriculas: `
          <b>Matrícula 2º semestre:</b> de 16 a 22 de junho`,
        prazo: ' ',
        linkVestibular: 'Inscrição aqui no <a href="https://www.extranet.ceuma.br/novoportal/vestibular/ceuma">Portal</a>',
      }
    ]
  },
];
